import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadCartListDetails } from "../../redux/actions";
import LocationCartList from "./LocationCartList";
import PaymentSummary from "./PaymentSummary";
import { useNavigate } from "react-router-dom";

const CartList = () => {
    const navigate  = useNavigate();
    const dispatch  = useDispatch();
    const user_data = useSelector((state) => state?.user_data?.user_data) ?? {};
    const [cartlist, setCartlist] = useState([]);
    const [visibleTables, setVisibleTables] = useState({});
    const [selectedLine, setSelectedLine] = useState({});
    const [totalLines, setTotalLines] = useState(0);
    const localCartId = localStorage.getItem('cartIds') ? JSON.parse(localStorage.getItem('cartIds')) : '';

    const fetchCartDetails = useCallback(async () => {

        let cartIds = [];
        
        if(user_data?.shopping_carts) {
            cartIds = user_data?.shopping_carts;
        } else if(localCartId) {
            cartIds = localCartId.map(item => item.cartId);
        }

        const data = await loadCartListDetails(cartIds, dispatch);

        setCartlist(data);

        if (data?.length > 0) {
            //set number of cart items
            let totalLine = data.reduce((count, cart) => {
                if (cart.lines?.length) {
                    return count + cart.lines.length;
                }
                return count;
            }, 0);
            setTotalLines(totalLine);

            // Initialize all tables as visible
            const initialVisibility = {};
            data.forEach((cart) => {
                initialVisibility[cart?.id] = true;
            });
            setVisibleTables(initialVisibility);
        }

        //data for payment summary
        if (data?.length > 0) {
            const transformCartData = (data) => {
                return data
                .filter((cart) => cart?.lines?.length > 0)
                .map((cart) => ({
                    shopping_cart_id: cart?.id,
                    selected_lines: cart?.lines.map(
                        (line) => line.product_variation.id
                    ),
                    selected_transferred_carts: [],
                }));
            };

            setSelectedLine(transformCartData(data));
        }
    });

    useEffect(() => {        
        fetchCartDetails();
    }, []);

    // Toggle function for each table
    const toggleTableVisibility = (cartId) => {
        setVisibleTables((prev) => ({
            ...prev,
            [cartId]: !prev[cartId], // Toggle visibility for the specific cart
        }));
    };

    return (
        <section className="hot-deals pt-20">
            <div className="container container-lg">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="d-flex align-items-center justify-content-between gap-0 w-100">
                        
                        <button
                            onClick={() => navigate(-1)}
                            className="ph ph-arrow-left animated-caret w-52 h-52 text-xl flex-center bg-main-product-50 hover-bg-main-product-50 text-white"
                        ></button>
                        
                        <h2 className="mb-0 text-blue flex-grow-1">
                            &nbsp;&nbsp;Shopping Basket
                        </h2>
                        </div>
                    </div>
                </div>
                <div className="row gy-4">
                    <div className="col-xl-9 col-lg-8">
                        <div className="cart-table border border-gray-100 rounded-8 px-20 py-28">
                            {totalLines === 0 && (
                                <h6 className="text-center mt-20">Cart data not found.</h6>
                            )}
                            {cartlist?.length > 0 && (
                                <div>
                                    {/* cart list */}
                                    {cartlist.map((cart, index) => (
                                        <div>
                                            {cart?.lines?.length === 0 && (
                                                // <h6 className="text-center mt-20">
                                                //   Carts data not found.
                                                // </h6>
                                                <></>
                                            )}
                                            {cart?.lines?.length > 0 && (
                                                <div key={cart.id}>
                                                    {/* Down Arrow Button */}
                                                    <button
                                                        className="btn mb-16 d-flex align-items-center gap-8 bg-main-product-50 hover-bg-main-product-50"
                                                        onClick={() => toggleTableVisibility(cart.id)}
                                                    >
                                                        {cart?.location?.name}
                                                        <i
                                                            className={`ph ph-arrow-${
                                                                visibleTables[cart.id] ? "down" : "up"
                                                            }`}
                                                        />
                                                    </button>

                                                    {/* Table Container with Scroll Animation */}
                                                    <LocationCartList
                                                        key={index}
                                                        {...cart}
                                                        visibleTables={visibleTables}
                                                        refreshCart={fetchCartDetails}
                                                    />
                                                    <br></br>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4">
                        <div className="cart-sidebar border border-gray-100 rounded-8 px-20 py-28 bg-light-grey">
                            {!selectedLine.length && (
                                <h6 className="mt-20">Payment summary not found.</h6>
                            )}
                            {selectedLine.length > 0 && (
                                <>
                                {/* payment summary */}
                                <PaymentSummary selectedLines={selectedLine} />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CartList;
